module.exports = __webpack_public_path__ + "static/media/success-pic-lion.ef867f01.png";